import { InfoCircleOutlined, PlusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
    Button,
    Checkbox,
    Col,
    Empty,
    Form,
    Image,
    Input,
    Modal,
    notification,
    Radio,
    Row,
    Select,
    Space,
    Table,
    Tag,
    Tooltip
} from "antd";
import { useEffect, useState } from "react";
import { addAndroidTemplateSingleapp, addTemplateSingleapp, deleteAndroidTemplateSingleapp, deleteTemplateSingleapp, getAndroidTemplateSingleapp, getTemplateSingleapp } from "../../../axios/api.device";
import { stringContaint } from "../../../utils/common";
import { gaEvent } from "../../../withTracker";

import i18n from "@src/locales";
import { useTranslation } from "react-i18next";

const { Column } = Table
const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    brand:any,
    updateTemplate: () => void,
}

export const TemplateContentSingleApp = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate,brand } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [showModal, setshowModal] = useState<boolean>(false);
    const [appList, setAppList] = useState<any[]>([]);
    const [appSearchList, setAppSearchList] = useState<any[]>([]);
    const [dataForm] = Form.useForm();
    const [selectApp, setSelectApp] = useState<any>({});
    const [androidSelectApps, setAndroidSelectApps] = useState<any[]>([]);
    const [selectKeys, setSelectKeys] = useState<any[]>([]);
    const [selectSingleKeys, setSelectSingleKeys] = useState<any[]>([]);
    const [blockSelectKeys, setBlockSelectKeys] = useState<any[]>([]);
    const [appOptions, setAppOptions] = useState<any[]>([]);
    const [iosSelectApps, setIosSelectApps] = useState<any[]>([]);
    const [selType, setSelType] = useState<string>("one");
    const [isAllow, setIsAllow] = useState<boolean>(true);
    const [iosBlockSelectApps, setIosBlockSelectApps] = useState<any[]>([]);

    const [iosAppsResult, setIosAppsResult] = useState<any[]>([]);
    const [androidAppsResult, setAndroidAppsResult] = useState<any[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");

    const [modalSelectAppKeys, setModalSelectKeys] = useState<any[]>([]);
    const [modalSelectApps, setModalSelectApps] = useState<any[]>([]);
    const [defaultOptions, setDefaultOptions] = useState<any[]>([1]);

    const { t } = useTranslation();

    var addClick = () => {
        setShowTable(2)
    }
     useEffect(() => {
        getDataInfo();
    }, [])
    const getDataInfo = () => {
        if (platform == "Android") {
            getAndroidTemplateSingleapp(templateId).then((result) => {
                if (result.data && result.data != null) {
                    setShowTable(2)
                    if (result.data.packageName && result.data.packageName.length > 0) {
                        setShowTable(2)
                    } else {
                        setShowTable(1)
                    }
                    if(result.appList && result.appList != null)
                    {  
                        setAppList(result.appList);
                        setAppSearchList(result.appList);
                        setAndroidAppsResult(result.appList);
                    }
                    //getApplist(res.appId, res.packageName);
                    var res = result.data;
                    var appListAll = result.appList;
                    var appIds = res.packageName;
                    setModalSelectKeys(appIds);
                    if (appIds.length != 0) {
                        var pageNames: string[] = [];
                        var sels: any[] = appListAll.filter((c:any) => {
                            var index = appIds.findIndex((b:any) => { return b == c.packageName })
                            var has = index != -1;
                            if (has) {
                                pageNames.push(c.packageName)
                            }
                            return has;
                        });
                        
                        if(!res.isSingleApp)
                        {
                            setAndroidSelectApps(sels);
                            setSelectKeys(pageNames);
                        }
                    }
                    if(res.isSingleApp)
                    {
                        var sel = appListAll.find((c:any) => { return c.packageName == appIds[0] });
                        var sep = {
                            name: sel.name,
                            appId: sel.packageName,
                            logoUrl: sel.logoUrl,
                            versionNumber: sel.versionNumber,
                            packageName: sel.packageName
                        }
                        setSelectApp(sep);
                        setSelectSingleKeys([sel.packageName]);
                    }
                    dataForm?.setFieldsValue(res);
                    if(res.isSingleApp)
                    {
                        setSelType("one");
                    }
                    else
                        setSelType("allow");
                } else {
                    //getApplist("", []);
                    setShowTable(1)
                }
            })
        } else {
            getTemplateSingleapp(templateId).then((res) => {
                if (res && res != null) {
                    if (res.selectedApps && res.selectedApps.length > 0) {
                        setShowTable(2)
                    } else {
                        setShowTable(1)
                    }
                    setIsAllow(res.isAllow);
                    if(res.selectedAppTypes && res.selectedAppTypes.length > 0)
                        setDefaultOptions(res.selectedAppTypes);
                    if (res.isSingleAppMode) {
                        //setShowType("one")
                        setSelType("one");
                        var item = res.selectedApps[0];
                        var sep = {
                            name: item.name,
                            appId: item.packageName,
                            logoUrl: item.icon,
                            versionNumber: item.version,
                            packageName: item.packageName
                        }
                        setSelectApp(sep);
                        setSelectSingleKeys([item.packageName]);
                        // getApplist(res.appIdentifier,[]);
                        dataForm?.setFieldsValue({
                            isCloseAutoLock: res.singleAppSetting?.disableAutoLock ?? false,
                            isCloseTouch: res.singleAppSetting?.disableTouch ?? false,
                            DisableDeviceRotation: res.singleAppSetting?.disableDeviceRotation ?? false,
                            DisableVolumeButtons: res.singleAppSetting?.disableVolumeButtons ?? false,
                            isClosePowerKey: res.singleAppSetting?.disableSleepWakeButton ?? false,
                            EnableAssistiveTouch: res.singleAppSetting?.enableAssistiveTouch ?? false,
                        });
                    } else {
                        //setShowType("more")
                        if(res.isAllow)
                            setSelType("allow")
                        else
                            setSelType("block")
                        var ses: any[] = [];
                        var seKeys: string[] = [];

                        res.selectedApps.forEach((item: any) => {
                            seKeys.push(item.packageName);
                            ses.push({
                                name: item.name,
                                appId: item.packageName,
                                logoUrl: item.icon,
                                versionNumber: item.version,
                                packageName: item.packageName
                            })

                        });
                        
                        if(res.isAllow) {
                            setSelectKeys(seKeys)
                            setIosSelectApps(ses)
                        } 
                        else {
                            setBlockSelectKeys(seKeys)
                            setIosBlockSelectApps(ses)
                        }
                        setModalSelectKeys(seKeys);
                        dataForm?.setFieldsValue({
                            isAllowWebClip: res.singleAppSetting?.allowWebClip ?? 1,
                        });
                    }
                    var ops: any[] = [];
                    res.selections.forEach((op: any, index: number) => {
                        ops.push({
                            label: op.description, value: index
                        })
                    });
                    setAppOptions(ops);
                    setIosAppsResult(res.selections)
                    var dataList: any[] = [];
                    res.selections[1]?.applications?.forEach((item: any) => {

                        dataList.push({
                            name: item.name,
                            appId: item.packageName,
                            logoUrl: item.icon,
                            versionNumber: item.version,
                            packageName: item.packageName
                        })
                    });
                    setAppList(dataList);

                    setAppSearchList(dataList);
                } else {
                    setShowTable(1)
                }
            })
        }

    }
    const getPackageNames=()=>{
        console.log("selectSingleKeys",selectSingleKeys,androidSelectApps,selectKeys)
        if(selType == "allow")
        {
            let packageNames= selectKeys.map(packageName=>{
            return  appList.find(c=>c.packageName == packageName)?.packageName;
            })
            return  Array.from(new Set(packageNames));
        }
        else
        {
            return selectSingleKeys;
        }
        //return packageNames.;
    }
    const getAppIds=(packageNames:[])=>{
        let appIds= packageNames.map(packageName=>{
            return  appList.find(c=>c.packageName == packageName).appId;
         })
         return appIds;
    }
    const addTemplateClick = () => {
        dataForm?.validateFields().then(
            (res) => {
                console.log(isAllow,selectSingleKeys,selectKeys,blockSelectKeys);
                if (isAllow) {
                    if(selType == "one" && selectSingleKeys.length == 0){
                        notification.error({ message: t("请选择应用") })
                        return;
                    }
                    if(platform !== "Android" && selType == "allow" && selectKeys.length == 1){
                        notification.error({ message: t("如果只选择一个应用，请选择单应用") })
                        return;
                    }
                }
                if (!isAllow && blockSelectKeys.length == 0) {
                    notification.error({ message: t("请选择应用") })
                    return;
                }
                if (platform == "Android") {
                    res.packageName=getPackageNames();
                    res.isSingleApp = (selType == "one")
                    console.log(res);
                    addAndroidTemplateSingleapp(templateId, res).then(() => {
                        if(selType == "allow"){
                            setBlockSelectKeys([]);
                            setIosBlockSelectApps([]);
                            setSelectApp({});
                            setSelectSingleKeys([]);
                        }
                        else if(selType == "one"){
                            setBlockSelectKeys([]);
                            setSelectKeys([]);
                            setIosSelectApps([]);
                            setAndroidSelectApps([]);
                            setIosBlockSelectApps([]);
                        }
                        updateTemplate();
                        notification.success({ message: t("成功") });
                        getDataInfo();
                    })
                } else {
                    var arg: any = {};
                    arg.isAllow = isAllow;
                    if(selType == "one")
                    {
                        arg.packageNames = selectSingleKeys;
                        arg.singleAppSetting = {
                            DisableAutoLock: res.isCloseAutoLock,
                            DisableTouch: res.isCloseTouch,
                            DisableDeviceRotation: res.DisableDeviceRotation,
                            DisableVolumeButtons: res.DisableVolumeButtons,
                            DisableSleepWakeButton: res.isClosePowerKey,
                            EnableAssistiveTouch: res.EnableAssistiveTouch,
                            AppIdentifier: selectApp.appId
                        }
                    }
                    else if(selType == "allow")
                    {
                        //res.packageName = selectKeys;
                        arg.packageNames = selectKeys;
                    }
                    else if(selType == "block")
                    {
                        //res.packageName = selectKeys;
                        arg.packageNames = blockSelectKeys;
                    }
                    // if(isAllow){
                    //     res.packageName = selectKeys;
                    //     arg.packageNames = selectKeys;
                    // }
                    // else{
                    //     res.packageName = selectKeys;
                    //     arg.packageNames = blockSelectKeys;
                    // }

                    // if (selType == "one") {
                    //     arg.singleAppSetting = {
                    //         DisableAutoLock: res.isCloseAutoLock,
                    //         DisableTouch: res.isCloseTouch,
                    //         DisableDeviceRotation: res.DisableDeviceRotation,
                    //         DisableVolumeButtons: res.DisableVolumeButtons,
                    //         DisableSleepWakeButton: res.isClosePowerKey,
                    //         EnableAssistiveTouch: res.EnableAssistiveTouch,
                    //         AppIdentifier: selectApp.appId
                    //     }
                    // }
                    if (selType == "allow" || selType == "block") {
                        arg.singleAppSetting = {
                            AllowWebClip: res.isAllowWebClip,
                        }
                    }
                    addTemplateSingleapp(templateId, arg).then(() => {
                        if(selType == "allow"){
                            setBlockSelectKeys([]);
                            setIosBlockSelectApps([]);
                            setSelectApp({});
                            setSelectSingleKeys([]);
                        }
                        else if(selType == "block"){
                            setSelectKeys([]);
                            setIosSelectApps([]);
                            setSelectApp({});
                            setSelectSingleKeys([]);
                        }
                        else if(selType == "one"){
                            setBlockSelectKeys([]);
                            setSelectKeys([]);
                            setIosSelectApps([]);
                            setIosBlockSelectApps([]);
                        }
                        updateTemplate();
                        notification.success({ message: t("成功") });
                        getDataInfo();
                    })
                }
            }, () => {

            })
    }
    const deleteTemplateClick = () => {
        if (platform == "Android") {
            deleteAndroidTemplateSingleapp(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm?.resetFields();
                setSelectApp({})
                getDataInfo();
            })
        } else {
            deleteTemplateSingleapp(templateId).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                dataForm?.resetFields();
                setSelectApp({})
                getDataInfo();
            })
        }
    }
    const templateRowSelection = {
        selectedRowKeys: modalSelectAppKeys,
        onChange(selectedRowKeys: any, selectedRows: any) {
            // 1. 获取当前表格展示的数据源（假设你的数据源是 appSearchList）
            const currentPageKeys = appSearchList.map(item => item.appId); 

            // 2. 更新 Keys（与上一轮逻辑相同，支持跨页和取消勾选）
            const preservedKeys = modalSelectAppKeys.filter(key => 
                !currentPageKeys.includes(key) || selectedRowKeys.includes(key)
            );
            const newKeys = Array.from(new Set([...preservedKeys, ...selectedRowKeys]));
            setModalSelectKeys(newKeys);

            // 3. 【核心修改】手动维护完整的 Rows 数据
            // 3.1 从旧的 rows 中，保留那些【不在当前页】的数据（跨页/跨分类的历史数据）
            const preservedRows = modalSelectApps.filter(row => 
                !currentPageKeys.includes(row.appId)
            );
            
            // 3.2 将【当前页最新勾选的完整行数据】与【其他页保留的行数据】合并
            const newRows = [...preservedRows, ...selectedRows];
            
            setModalSelectApps(newRows);
        }
    };
    const androidAppDeleteClick = (item: any) => {
        var appId = platform == "Android" ? item.packageName : item.appId;
        if(selType != "block"){
            console.log('selectKeys' ,selectKeys);
            var ids = selectKeys.filter(c => {
                return c != appId;
            });
            setSelectKeys(ids);

            var modalIds = modalSelectAppKeys.filter(c => {
                return c != appId;
            });
            setModalSelectKeys(modalIds);
        }
        else{
            var ids = blockSelectKeys.filter(c => {
                return c != appId;
            });
            setBlockSelectKeys(ids)
            var modalIds = modalSelectAppKeys.filter(c => {
                return c != appId;
            });
            setModalSelectKeys(modalIds);
        }
        if (platform === "Android") {
            var appList = androidSelectApps.filter(c => {
                return c.packageName != appId;
            });
            setAndroidSelectApps(appList);
        } else {
            if (selType === "one") {
                setSelectApp({});
            } else if(selType === "allow") {
                var iosAppList = iosSelectApps.filter(c => {
                    return c.appId != appId;
                });
                setIosSelectApps(iosAppList);
            } else if(selType === "block") {
                var iosAppList = iosBlockSelectApps.filter(c => {
                    return c.appId != appId;
                });
                setIosBlockSelectApps(iosAppList);
            }
        }
    }
    const onSearch = (value: string) => {
        var arr = appList?.filter(c => {
            return stringContaint(value, c.name);
        })
        setAppSearchList([...arr]);
    }

    const templateColumns = [

        {
            title: '图标',
            dataIndex: 'logoUrl',
            filterMultiple: false,
            key: "logoUrl",
            render: (logoUrl: any) => <Image width={50} height={50} src={logoUrl}></Image>
        },
        {
            title: '应用名称',
            dataIndex: 'name',
            filterMultiple: false,
            key: 'name',
        },
        {
            title: '包名',
            dataIndex: 'packageName',
            key: 'packageName',
        },
        {
            title: '版本',
            dataIndex: 'versionNumber',
            key: 'versionNumber',
        },
    ];
    function appOptionChange(checkedValues: any) {
        // 1. 更新 defaultOptions 状态
        setDefaultOptions(checkedValues);

        // 2. 构建新的应用列表 dataList
        var dataList: any[] = [];
        checkedValues.forEach((inx: any) => {
            iosAppsResult[inx]?.applications.forEach((item: any) => {
                dataList.push({
                    name: item.name,
                    appId: item.packageName,
                    logoUrl: item.icon,
                    versionNumber: item.version,
                    packageName: item.packageName
                })
            });
        });

        // 3. 关键步骤：计算新的选中 Keys (合并策略)
        // 获取当前模态框中已选中的 Keys
        const currentSelectedKeys = new Set(modalSelectAppKeys);
        
        // 过滤出 "仍然在新列表中存在" 的已选 Key
        // 这保证了跨分类选择时，之前选中的同名应用不会被清空
        const preservedKeys = [...currentSelectedKeys].filter(key => 
            dataList.some(item => item.appId === key || item.packageName === key)
        );

        // 4. 更新状态
        setAppList(dataList);
        
        // 这里不直接使用 selectKeys，而是使用 preservedKeys
        // 如果你希望在切换分类时保留所有之前选的（即使不在当前分类），直接用 modalSelectAppKeys
        // 如果你希望切换分类时只保留当前分类里还存在的，用 preservedKeys
        setModalSelectKeys(preservedKeys); 

        // 5. 处理搜索
        var arr = dataList?.filter(c => stringContaint(searchValue, c.name));
        setAppSearchList([...arr]);
    }
    function showTypeChange(e: any) {
        setSelType(e);
        if(e === "one"){
            //setShowType("one")
            setIsAllow(true)
        }
        else if(e === "allow")
        {
            //setShowType("more")
            setIsAllow(true)
        }
        else if(e === "block"){
            //setShowType("more")
            setIsAllow(false)
        }
        setModalSelectKeys([]);
        setModalSelectApps([]);
    }

    const onModalOk = () => {
        // 1. 统一更新 Keys（直接使用模态框的最终结果，不再与外部旧数据合并）
        if (selType == "one") {
            if (modalSelectAppKeys.length > 0) {
                setSelectSingleKeys(modalSelectAppKeys);
            } else {
                // 如果用户在模态框里把所有项都取消了，外部也要同步清空
                setSelectSingleKeys([]); 
            }
        } else if (selType == "allow") {
            setSelectKeys(modalSelectAppKeys);
        } else if (selType == "block") {
            setBlockSelectKeys(modalSelectAppKeys);
        }

        // 2. 统一更新 Apps 数据（同样不再合并，直接赋值）
        if (platform == "Android") {
            if (selType == "one") {
                if (modalSelectApps.length > 0) {
                    setSelectApp(modalSelectApps[0]);
                } else {
                    setSelectApp(null); // 取消全选时也要清空
                }
            } else if (selType == "allow") {
                setAndroidSelectApps(modalSelectApps);
            }
        } else {
            if (selType == "one") {
                if (modalSelectApps.length > 0) {
                    setSelectApp(modalSelectApps[0]);
                } else {
                    setSelectApp(null);
                }
            } else if (selType == "allow") {
                setIosSelectApps(modalSelectApps);
            } else if (selType == "block") {
                setIosBlockSelectApps(modalSelectApps);
            }
        }

        // 3. 关闭模态框并重置搜索
        setSearchValue("");
        setshowModal(false);
    }

    const showModalKeys = () => {
        appOptionChange(defaultOptions);
    }

    const unique = (arr: any, val: string) => {
        const res = new Map();
        return arr.filter((item: any) => !res.has(item[val]) && res.set(item[val], 1));
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("应用规则")}</Col>
                {platform != "Android" && (
                    <Col style={{ marginLeft: 36 }}>
                        {templateTab?.availabilities?.map((c: any) => (
                            <Tooltip title={
                                i18n.language === "zh" ? `只能在${c}以上的设备上才能配置` : 
                                i18n.language === "en" ? `Only be configured on devices above iOS ${c}` : ""
                            }>
                                <Tag color="cyan">{c}</Tag>
                            </Tooltip >
                        ))}
                        {templateTab?.supervisedRequired && (
                            <Tooltip title={t("只适用于受监督设备")}>
                                <Tag color="purple">S</Tag>
                            </Tooltip>
                        )}
                    </Col>
                )}
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (

                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {platform == "Android" ? t("此模式需要在获取到device owner权限的设备中使用") : t("设置后,设备只能允许指定的应用,此模式需要在收监督的设备中使用")} </p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); gaEvent("templateContentSingleApp", "onClick", "addClick") }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <div style={{ width: "100%" }}>
                        <Form
                            style={{ width: "90%", marginTop: 36 ,marginLeft:45}}
                            layout="vertical"
                            form={dataForm}
                            labelCol={{ span: 8 }}
                            initialValues={{isCloseStatusBar:true,isClosePushBar:true,isCloseAutoLock:true,
                                isCloseTouch:true,isClosePowerKey:true,isCloseBackKey:true,DisableDeviceRotation:true,
                                DisableVolumeButtons:true,EnableAssistiveTouch:true,isClosePassword:true,isAllowWebClip:true
                            }}
                        >

                            {(platform == "IOS" || platform == "Android") && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("应用规则")} name="isSingleAppMOde"  extra={<><InfoCircleOutlined /> {t("设置多个允许的应用")}</>}>
                                            <Col span={16}>
                                                <Select value={selType} onChange={showTypeChange} >
                                                    <Select.Option value="one">{t("单应用")}</Select.Option>
                                                    <Select.Option value="allow">{t("应用白名单")}</Select.Option>
                                                    <Select.Option hidden={platform == "Android"} value="block">{t("应用黑名单")}</Select.Option>
                                                </Select>
                                            </Col>
                                        </Item>
                                    </Col>
                                    {/* <Col span={8} >
                                        <p style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px" }}><InfoCircleOutlined />&nbsp;&nbsp;&nbsp;设置多个允许的应用</p>
                                    </Col> */}
                                </Row>
                            )}
                            {(platform == "IOS" && selType == "allow") && (
                                <>
                                    {iosSelectApps.map((item: any) =>
                                        <Row key={item.appId}>
                                            <Col span={16}>
                                                <Item label={t("应用")} name="status" rules={[{ required: false }]}>
                                                    <Space>
                                                        <Image width={50} src={item?.logoUrl}></Image>
                                                        <p>{item.name}</p>
                                                    </Space>
                                                </Item>
                                            </Col>
                                            {/* <Col span={2} >
                                                <a onClick={() => { setshowModal(true); gaEvent("templateContentSingleApp", "onClick", "setshowModal") }} style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px", color: "#007ACC" }} >修改</a>
                                            </Col> */}
                                            <Col span={2} style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px" }}>
                                                <a onClick={() => { androidAppDeleteClick(item); gaEvent("templateContentSingleApp", "onClick", "androidAppDeleteClick") }} style={{ marginLeft: "16px", textAlign: "left", lineHeight: "110px", color: "#007ACC" }} >{t("删除")}</a>
                                            </Col>
                                        </Row>
                                    )}
                                    <Row>
                                        <Col span={16}>
                                            <Item label={t("应用")} name="status" rules={[{ required: false }]}>
                                                <PlusCircleOutlined onClick={() => { 
                                                    // setModalSelectKeys([...selectKeys, ...modalSelectAppKeys]); 
                                                    setshowModal(true);
                                                    appOptionChange(defaultOptions);
                                                }} style={{ fontSize: 36 }} />
                                            </Item>
                                        </Col>
                                    </Row>

                                </>
                            )}
                            {(platform == "IOS" && selType == "block") && (
                                <>
                                    {iosBlockSelectApps.map((item: any) =>
                                        <Row key={item.appId}>
                                            <Col span={16}>
                                                <Item label={t("应用")} name="status" rules={[{ required: false }]}>
                                                    <Space>
                                                        <Image width={50} src={item?.logoUrl}></Image>
                                                        <p>{item.name}</p>
                                                    </Space>
                                                </Item>
                                            </Col>
                                            <Col span={2} style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px" }}>
                                                <a onClick={() => { androidAppDeleteClick(item); }} style={{ marginLeft: "16px", textAlign: "left", lineHeight: "110px", color: "#007ACC" }} >{t("删除")}</a>
                                            </Col>
                                        </Row>
                                    )}
                                    <Row>
                                        <Col span={16}>
                                            <Item label={t("应用")} name="status" rules={[{ required: false }]}>
                                                <PlusCircleOutlined onClick={() => { 
                                                    // setModalSelectKeys([...selectKeys, ...modalSelectAppKeys]); 
                                                    setshowModal(true); 
                                                    appOptionChange(defaultOptions);
                                                }} style={{ fontSize: 36 }} />
                                            </Item>
                                        </Col>
                                    </Row>

                                </>
                            )}
                            {platform == "Android" && selType == "allow" && (
                                <>
                                    {androidSelectApps.map((item) =>
                                        <Row key={item.appId}>
                                            <Col span={16}>
                                                <Item label={t("应用")} name="status" rules={[{ required: false }]}>
                                                    <Space>
                                                        <Image width={50} src={item?.logoUrl}></Image>
                                                        <p>{item.name}</p>
                                                    </Space>
                                                </Item>
                                            </Col>
                                            <Col span={2} style={{ marginLeft: "16px", textAlign: "left", lineHeight: "32px" }}>
                                                <a onClick={() => { androidAppDeleteClick(item); gaEvent("templateContentSingleApp", "onClick", "androidAppDeleteClick") }} style={{ marginLeft: "16px", textAlign: "left", lineHeight: "110px", color: "#007ACC" }} >{t("删除")}</a>
                                            </Col>
                                        </Row>
                                    )}
                                    <Row>
                                        <Col span={16}>
                                            <Item label={t("应用")} name="status" rules={[{ required: false }]}>
                                          <PlusCircleOutlined onClick={() => { setshowModal(true);appOptionChange(defaultOptions);   }} style={{ fontSize: 36 }} />
                                            </Item>
                                        </Col>

                                    </Row>

                                </>
                            )}
                            
                            {(["IOS","Android"].includes(platform) && selType == "one") && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("应用")} name="status" rules={[{ required: false }]}>
                                            {selectApp.logoUrl && (
                                                <Space>
                                                    <Image width={50} src={selectApp?.logoUrl}></Image>
                                                    <p>{selectApp.name}</p>
                                                </Space>


                                            )}
                                            {!selectApp.logoUrl && (

                                                <PlusCircleOutlined onClick={() => { setshowModal(true); appOptionChange(defaultOptions); }} style={{ fontSize: 36 }} />
                                            )}
                                        </Item>
                                    </Col>
                                    {selectApp.logoUrl && (
                                        <Col span={2} >
                                            <a onClick={() => { setshowModal(true); appOptionChange(defaultOptions); }} style={{ marginLeft: "16px", textAlign: "left", lineHeight: "110px", color: "#007ACC" }} >{t("修改")}</a>
                                        </Col>
                                    )}
                                </Row>
                            )}

                            {platform == "Android" && brand != "HONOR"  && brand != "Oppo" && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("暂停单应用密码")} name="isSuspend" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("连续点击主屏4下,输入密码能够暂停单应用模式")}</>}>
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>
      
                                </Row>
                            )}
                            {platform == "Android" && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("关闭状态栏")} name="isCloseStatusBar" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("隐藏状态栏")}</>}>
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>

                                </Row>
                            )}
                            {platform == "Android" && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("关闭推送栏")} name="isClosePushBar" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("隐藏推送栏")}</>}>
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>
           
                                </Row>

                            )}
                            {((selType == "allow" || selType == "block") && platform == "IOS") && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("是否允许Web Clip")} name="isAllowWebClip" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("快速跳转到网页的icon出现在主屏幕中")}</>}>
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>

                                </Row>
                            )}
                            {(selType == "one") && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("关闭自动锁屏")} name="isCloseAutoLock" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("屏幕会常亮")}</>}>
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>

                                </Row>
                            )}
                            {(selType == "one") && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("关闭触控")} name="isCloseTouch" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("无法使用触摸屏做任何操作")}</>}> 
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>

                                </Row>
                            )}
                            {selType == "one" && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("关闭电源按键")} name="isClosePowerKey" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("无法休眠")}</>}>
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>
     
                                </Row>
                            )}
                            {platform == "Android" && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("关闭返回键")} name="isCloseBackKey" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("返回键会被关闭")}</>}>
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>

                                </Row>
                            )}
                            {(platform == "IOS" && selType == "one") && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("关闭旋转屏幕")} name="DisableDeviceRotation" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("自动旋转屏幕会被关闭")}</>}>
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>
              
                                </Row>
                            )}
                            {(platform == "IOS" && selType == "one") && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("关闭音量按键")} name="DisableVolumeButtons" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("无法调节音量")}</>}>
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>
  
                                </Row>
                            )}



                            {(platform == "IOS" && selType == "one") && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("关闭侧开关")} name="EnableAssistiveTouch" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("无法使用侧开关功能")}</>}> 
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>

                                </Row>
                            )}
                            {platform == "Android" && brand !="HONOR" && brand !="Oppo" && (
                                <Row>
                                    <Col span={16}>
                                        <Item label={t("关闭密码")} name="isClosePassword" rules={[{ required: true }]} extra={<><InfoCircleOutlined /> {t("无需输入密码解锁设备")}</>}>
                                            <Radio.Group defaultValue={true}>
                                                <Radio value={true}>{t("是")}</Radio>
                                                <Radio value={false}>{t("否")}</Radio>
                                            </Radio.Group>
                                        </Item>
                                    </Col>

                                </Row>
                            )}
                        </Form>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); gaEvent("templateContentSingleApp", "onClick", "addTemplateClick") }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); gaEvent("templateContentSingleApp", "onClick", "deleteTemplateClick") }}>{t("删除规则")}</Button>
                        </div>
                    </div>
                )}
                <Modal
                    maskClosable={false}
                    title={t("添加应用")}
                    destroyOnClose={true}
                    open={showModal}
                    onOk={() => { onModalOk() }}
                    onCancel={() => { 
                        // setModalSelectKeys([]);
                        // setModalSelectApps([]);
                        setSearchValue("");
                        setshowModal(false); 
                    }}
                    okText={t("确认")}
                    cancelText={t("取消")}
                >
                    <Space direction="vertical" style={{ width: "100%" }}>
                        <Row>
                            <Col span={4}>{t("应用名称")}:</Col>
                            <Col span={12}>   <Input.Search placeholder={t("输入查询名称")} allowClear enterButton={t("搜索")} onSearch={(c: string) => {
                                setSearchValue(c);
                                onSearch(c);
                            }} /></Col>
                            {platform == "IOS" && <Col  span={8} >
                                <Checkbox.Group 
                                    style={{ marginLeft: 16 }} 
                                    options={appOptions.map((item)=>{
                                        item.label = t(item.label)
                                        return item 
                                    })} 
                                    defaultValue={defaultOptions} 
                                    onChange={appOptionChange}
                                ></Checkbox.Group>
                            </Col>
                            }
                        </Row>
                        <Row>

                            <Table 
                                scroll={{ y: '400px' }} 
                                columns={templateColumns.map((item)=>{
                                    item.title = t(item.title)
                                    return item 
                                })} 
                                pagination={false} 
                                style={{ width: "100%" }} 
                                dataSource={appSearchList} 
                                rowSelection={{
                                    type: (["IOS","Android"].includes(platform) && selType == "one") ? 'radio' : 'checkbox',
                                    ...templateRowSelection,
                                }} 
                                rowKey={platform == "IOS" ? "appId":"packageName"} 
                                locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                            />
                        </Row>
                    </Space>
                </Modal>
            </Row>
        </div>
    </>);
};